// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab1b5302","453":"e90fd717","455":"057c93e1"}[chunkId] + ".chunk.js";
};